/** QR code image (rendered via the qrserver.com API, in Kaden brand colors). */
export function QRCode({ url, size = 100 }: { url: string; size?: number }) {
  const src = `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(url)}&bgcolor=1a2820&color=dab87a&format=svg`;
  return <img src={src} alt="QR Code" width={size} height={size} className="kd-qr-code" loading="lazy" />;
}
